<template>
  <div v-if="isGetRequestPending"><ms-loading :size="'large'" :justify="true"></ms-loading></div>
  <section v-else class="message-list-wrapper">
    <ul class="message-list">
      <li class="message-search">
        <ms-search v-model="searchText" @keyup="() => keys++"></ms-search>
      </li>
    </ul>
    <ul class="message-list">
      <li v-for="entry in filtered" :key="entry.id" class="message-list-item" @click="selectTemplate(entry)">
        <!-- <div>{{ entry.id }}</div> -->
        <div class="message-list-item-content">
          <div v-if="entry.usage" class="message-list-item-usage">used {{ entry.usage }} time(s)</div>
          <div class="message-list-item-name">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <label v-html="$options.filters.highlight(entry.name, searchText)"></label>
          </div>

          <!-- <div v-if="entry.updatedAt" class="message-list-item-meta">
            updated by {{ entry.updatedBy }} on {{ new Date(entry.updatedAt).toLocaleString() }}
          </div>
          <div v-else class="message-list-item-meta">created by {{ entry.createdBy }} on {{ new Date(entry.createdAt).toLocaleString() }}</div> -->
          <div v-if="entry.description" class="message-list-item-description">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="$options.filters.highlight(entry.description, searchText)"></span>
          </div>

          <ul v-if="entry.tags && entry.tags.length" class="tag-list">
            <li v-for="tag in entry.tags" :key="tag" class="tag-list-item">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="$options.filters.highlight(tag, searchText)">{{ tag }}</span>
            </li>
          </ul>
        </div>

        <div class="message-list-item-open-action">
          <ms-icon name="ChevronRightSmall"></ms-icon>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import MsSearch from './../ms/Search';
import MsIcon from './../ms/Icon';
import MsLoading from './../ms/Loading';

import { getSubject, subscribeOnItemChanged, unsubscribeOnItemChanged } from './../../utils/office';

export default {
  components: {
    'ms-search': MsSearch,
    'ms-icon': MsIcon,
    'ms-loading': MsLoading
  },
  data() {
    return { searchText: '', keys: 0 };
  },
  computed: {
    ...mapGetters({
      collection: 'messages/sorted'
    }),
    ...mapState({
      isGetRequestPending: s => s.messages.isGetRequestPending
    }),
    filtered() {
      if (!this.collection || !this.collection.length) {
        return [];
      }

      if (this.searchText && this.searchText.length) {
        return this.collection.filter(s => this.match(s, this.searchText));
      }
      return this.collection;
    }
  },
  async created() {
    subscribeOnItemChanged(this.initalize);

    await this.$store.dispatch('messages/getCollection');
  },
  destroyed() {
    unsubscribeOnItemChanged(this.initalize);
  },
  async mounted() {
    this.$trackEvent('Template List page opened');
    await this.initalize();
  },

  methods: {
    async initalize(item) {
      const subject = await getSubject();

      if (subject && subject.toLowerCase().startsWith('re:')) {
        this.searchText = 'Reply';
      } else {
        this.searchText = '';
      }
    },
    match(s, searchText) {
      if (!this.searchText || !this.searchText.length) {
        return [];
      }

      const parts = this.searchText.split(' ');

      let matchCount = 0;
      for (const part of parts) {
        if (
          s.name.toLowerCase().indexOf(part.toLowerCase()) > -1 ||
          s.description.toLowerCase().indexOf(part.toLowerCase()) > -1 ||
          (s.tags || []).find(tag => tag.toLowerCase().indexOf(part.toLowerCase()) > -1)
        ) {
          matchCount++;
        }
      }

      return matchCount === parts.length;
    },
    async selectTemplate(template) {
      this.$trackEvent('Template selected', {
        id: template.id,
        search: this.searchText,
        keys: this.keys,
        match: this.match(template, this.searchText)
      });

      await this.$store.dispatch('navigation/push', {
        path: 'message',
        params: {
          id: template.id
        }
      });
    }
  }
};
</script>

<style lang="scss">
.message-list-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  > .message-list {
    &:last-child {
      overflow-y: scroll;
    }
  }
}
.message-list {
  padding: 0;
  margin: 0;
  list-style: none;

  > li {
    position: relative;
    box-sizing: border-box;
    outline: transparent;
    // margin: 0.75rem 0;
  }

  .message-search {
    padding: 0rem 2.75rem 0 1rem;
  }

  .message-list-item {
    min-height: 54px;

    border-bottom: 1px solid rgb(237, 235, 233);
    display: flex;
    width: 100%;
    background-color: rgb(255, 255, 255);
    // margin: 10px 0;
    // box-shadow: 0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108);
    // transition: box-shadow 0.2s ease;

    padding: 0.75rem 1rem;

    &:hover {
      background-color: rgb(237, 235, 233);
      // box-shadow: 0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108);
      cursor: pointer;

      * {
        cursor: pointer;
      }
    }
    .message-list-item-content {
      flex: 1;
      margin-right: 1rem;
    }
    .message-list-item-usage {
      font-size: 0.5rem;
      text-align: right;
      color: rgb(161, 159, 157);
    }
    .message-list-item-name {
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 0.25rem;
    }
    .message-list-item-description {
      font-size: 0.75rem;
      font-weight: 300;
      margin-bottom: 0.25rem;
    }

    .message-list-item-open-action {
      flex: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      color: rgb(161, 159, 157);

      line-height: 1;
    }

    .tag-list {
      margin: 0;
      padding: 0.15rem 0 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .tag-list-item {
        display: inline-flex;
        padding: 0.2rem 0.25rem;
        border: 1px solid rgb(161, 159, 157);
        background: transparent;
        border-radius: 2px;
        box-sizing: border-box;
        font-size: 0.7rem;
        position: relative;
        line-height: 1;

        margin-right: 0.25rem;
        margin-bottom: 0.25rem;
      }
    }
  }
}
</style>
